export default function setTimeplanUnit(timeplanUnits, originalTPU, updatedValues) {
  if (timeplanUnits.find(tpu => tpu.id === originalTPU.id)) {
    return timeplanUnits.map((tpu) => {
      if (tpu.id === originalTPU.id) {
        return originalTPU.merge(updatedValues);
      }
      return tpu;
    });
  }

  const oldValues = timeplanUnits.filter(tpu => tpu.id !== originalTPU.id);
  return oldValues.push(originalTPU.merge(updatedValues));
}
